import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {faPen} from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { TerminalComponent } from '../terminal/terminal.component';
import { environment } from 'src/environments/environment';
import { iccidValidator } from 'src/app/utils/validators/iccid-validator';
import { ApiAmenaService } from '../../services/api-amena.service';
import { NormalizadorService } from '../../services/normalizador.service';
import { MobilePackService } from '../../services/mobile-pack.service';
import { GeneralService } from '../../services/general.service';
import { ShoppingCartService } from '../../services/shopping-cart-service';
import { UserDataListener } from '../../interface/user-data-listener';
import { TerminalListener } from '../../interface/terminal-listener';
import { RateListener } from '../../interface/rate-listener';
import { AmenaListener } from '../../interface/amena-listener';
import { Rate } from '../../interface/rate';
import { UserDataModel } from '../../interface/user-data-model';
import { TerminalModel } from '../../interface/terminal-model';
import { DigoService } from 'src/app/services/digo.service';

@Component({
    selector: 'app-mobile-pack',
    templateUrl: './mobile-pack.component.html',
    styleUrls: ['./mobile-pack.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class MobilePackComponent implements OnInit, UserDataListener, TerminalListener, RateListener, AfterViewInit, OnDestroy {
    @Input() index: number;
    @Input() stepperChild: MatStepper;
    @Input() amenaListener: AmenaListener;
    @Output() onItemAdded = new EventEmitter();
    @ViewChild('terminal') terminal: TerminalComponent;

    public secondFormGroup: FormGroup;

    public env = environment;
    public pdv: any;
    public router: string;
    public rate: Rate = null;
    public rateAccess: any = ['mobile', '4g'];
    public realtechnology: any[] = [];
    public typeOperation = 'registration';
    public portability_type_client = '';
    public faPen = faPen;
    public showMobilePromo = false;
    public providers = [];
    public isRetramitacion = false;
    public isAmenaEnCasa: boolean = false;
    destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private _router: Router,
        private formBuilder: FormBuilder,
        private amenaService: ApiAmenaService,
        private normalizadorService: NormalizadorService,
        private mobilePackService: MobilePackService,
        private modalService: NgbModal,
        private generalService: GeneralService,
        private shoppingCartService: ShoppingCartService,
        private digoService: DigoService
    ) {
        this.router = _router.url;
    }

    ngOnInit(): void {
        this.secondFormGroup = this.formBuilder.group({
            type_operation: ['', Validators.required],
            rate: ['', Validators.required],
            portability_phone: [''],
            portability_operator: [''],
            portability_type_client: [''],
            portability_iccid: [''],
            portability_client: [''],
            iccid: [''],
            terminal: [''],
            terminal_payment_type: [''],
            terminal_insurance: [''],
            stepper_index: [this.stepperChild.selectedIndex],
            resegmentation: [''],
            resegmentation_from_type: [''],
            resegmentation_type: [''],
            cp_vat: [''],
            cp_price: [''],
            cp_price_without_vat: [''],
        });
        this.mobilePackService.getProviders()
            .subscribe((response: any) => {
                if (response) {
                    this.providers = response.msg;
                }
            });

        this.amenaService.getPDV()
            .subscribe(data => {
                if (data) {
                    this.pdv = data;
                    this.setTechnologyFirstStepMovil(this.pdv);
                }
            });

        // Set tecnología en caso de ser el primer paso de una convergente
        if (this.index === 0 && this.router === '/amena/convergente') {
            this.mobilePackService.getRate()
                .subscribe(data => {
                    this.rate = data;
                    this.secondFormGroup.get('rate').patchValue(this.rate);
                });

            this.normalizadorService.getRealtechnology()
                .subscribe(data => {
                    this.realtechnology = data;
                });
        }

        // Muestra o oculta la promo de 50% para las lineas adicionales
        if (this.index === 0 || this.router === '/amena/solo_movil') {
            this.showMobilePromo = false;
        }else{
            this.showMobilePromo = true;
        }
    }

    ngAfterViewInit() {
        this.secondFormGroup.get('stepper_index').patchValue(this.stepperChild.selectedIndex);
        // Si hay cambios en el formulario, actualizamos los datos tanto en el carrito como en el borrador
        this.secondFormGroup.statusChanges
            .subscribe(form => {
                if ((this.secondFormGroup.get('rate').value !== null && this.secondFormGroup.valid)) {
                    const itemsForms = this.shoppingCartService.getShoppingCart().getOperation().getItemForms();
                    // Tenemos lineas adicionales
                    if (itemsForms && itemsForms.length > 1) {
                        this.evaluateICCID(itemsForms);
                        this.evaluateMSISDN(itemsForms);
                    }
                    this.generalService.setFormularioMobilePack(this.secondFormGroup);
                }
            });

        // Retomar tramitación
        this.generalService.getEmptyFormMobilePack()
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {

                if (data != null && typeof data[this.index] !== 'undefined') {
                    const mobile = data[this.index];
                    this.isRetramitacion = true;
                    this.rate = mobile.rate;
                    this.typeOperation = mobile.type_operation;
                    this.portability_type_client = mobile.portability_type_client;
                    this.secondFormGroup.patchValue({
                        type_operation: mobile.type_operation,
                        rate: mobile.rate,
                        portability_phone: mobile.portability_phone,
                        portability_operator: mobile.portability_operator,
                        portability_type_client: mobile.portability_type_client,
                        portability_iccid: mobile.portability_iccid,
                        portability_client: mobile.portability_client,
                        iccid: mobile.iccid,
                        terminal: mobile.terminal,
                        terminal_payment_type: mobile.terminal_payment_type,
                        terminal_insurance: mobile.terminal_insurance,
                        stepper_index: mobile.stepper_index,
                        resegmentation: mobile.resegmentation,
                        resegmentation_from_type: mobile.resegmentation_from_type,
                        resegmentation_type: mobile.resegmentation_type,
                        cp_vat: mobile.cp_vat,
                        cp_price: mobile.cp_price,
                        cp_price_without_vat: mobile.cp_price_without_vat,
                    });

                    // Descomentar para que amena en casa sea obligatorio el terminal
                    // if (mobile.rate && mobile.rate.type === '4G') {
                    //     this.isAmenaEnCasa = true;
                    //     this.secondFormGroup.get('terminal').setValidators(Validators.required);
                    //     this.secondFormGroup.get('terminal').updateValueAndValidity();
                    // }
                    this.changeTypeOperation();
                }
            });

    }

    evaluateICCID(itemsForms: FormGroup[]) {
        const typeForms = itemsForms
            .filter(form => (
                form.get('portability_iccid').value !== '' &&
                form.get('portability_type_client').value === 'prepaid' &&
                (form.get('type_operation').value === 'portability' || form.get('type_operation').value === 'portability_logistica')) ||
                (form.get('iccid').value !== '')
            );// && this.showEntregaSim));

        if (typeForms && typeForms.length > 1) {
            let iccids:string[] = [];
            typeForms.map((form) => {
                if (form.get('iccid').value !== '') {
                    iccids.push(form.get('iccid').value);
                }
                if (form.get('portability_iccid').value !== '') {
                    iccids.push(form.get('portability_iccid').value);
                }
            });
            let unique = [...new Set(iccids)];
            if (unique.length < iccids.length) {
                // Buscamos cuales de los iccids es el repetido el campo que tenga ese valor es el que falla
                let conflictValue = [...new Set(iccids.filter((value, index, self) => self.indexOf(value) !== index))]
                if (itemsForms[this.index].get('iccid').value !== '' && itemsForms[this.index].get('iccid').value === conflictValue[0]) {
                    itemsForms[this.index].controls['iccid'].setErrors({isRepeat: true});
                }
                if (itemsForms[this.index].get('portability_iccid').value !== '' && itemsForms[this.index].get('portability_iccid').value === conflictValue[0]) {
                    itemsForms[this.index].controls['portability_iccid'].setErrors({isRepeat: true});
                }
            } else {
                itemsForms.map(form => {
                    if (form.controls['iccid'].errors) {
                        form.controls['iccid'].setErrors(null);
                    }
                    if (form.controls['portability_iccid'].errors) {
                        form.controls['portability_iccid'].setErrors(null);
                    }
                })
            }
        }
    }

    evaluateMSISDN(itemsForms: FormGroup[]) {
        const typeForms = itemsForms.filter(form => form.get('portability_phone').value !== '' && (form.get('type_operation').value === 'portability_logistica' || form.get('type_operation').value === 'portability'))
        if (typeForms && typeForms.length > 1) {
            let msisdns:string[] = [];
            typeForms.map((form) => {
                if (form.get('portability_phone').value !== '') {
                    msisdns.push(form.get('portability_phone').value);
                }
            });
            let unique = [...new Set(msisdns)];
            if (unique.length < msisdns.length) {
                itemsForms[this.index].controls['portability_phone'].setErrors({isRepeat: true});
            } else {
                itemsForms.map(form => {
                    if (form.controls['portability_phone'].errors) {
                        form.controls['portability_phone'].setErrors(null);
                    }
                })
            }
        }
    }

    setTechnologyFirstStepMovil(data) {
        // Televenta
        if (data.info.telesales === 1 && this.typeOperation !== 'migration') {
            this.typeOperation = 'registration_logistica';
        }
        // amena en casa
        if (data.permissions.AMENA_VENTA_DE_TERMINALES === 'PERMITE_LA_VENTA_DE_TERMINALES') {
            this.rateAccess = ['mobile', '4g'];
        } else {
            this.rateAccess = 'mobile';
        }
    }

    setTechnologyLineasAdicionales() {
        if (this.pdv.permissions.AMENA_VENTA_DE_TERMINALES === 'PERMITE_LA_VENTA_DE_TERMINALES') {
            this.rateAccess = ['mobile', '4g'];
        } else {
            this.rateAccess = 'mobile';
        }
    }

    changeTypeOperation() {
        // Añadimos validaciones dependiendo si es un alta o una portabilidad
        if (this.typeOperation === 'portability' || this.typeOperation === 'migration' || this.typeOperation === 'registration') {
            this.secondFormGroup.get('terminal').patchValue('');
            this.secondFormGroup.get('terminal_payment_type').patchValue('');
            this.secondFormGroup.get('terminal_insurance').patchValue('');
        }
        if (this.typeOperation === 'portability' || this.typeOperation === 'portability_logistica') {
            this.secondFormGroup.get('portability_phone').setValidators([
                Validators.required,
                Validators.pattern('[0-9 ]*'),
                Validators.minLength(9),
                Validators.maxLength(9)
            ]);
            this.secondFormGroup.get('portability_phone').enable();
            this.secondFormGroup.get('portability_type_client').setValidators(Validators.required);
            this.secondFormGroup.get('portability_iccid').setValidators([Validators.required, iccidValidator(this.digoService)]);
            this.secondFormGroup.get('portability_operator').setValidators(Validators.required);
        } else if (this.typeOperation === 'migration') {
            this.secondFormGroup.get('portability_phone').setValidators([
                Validators.required,
                Validators.pattern('[0-9 ]*'),
                Validators.minLength(9),
                Validators.maxLength(9)
            ]);
            this.secondFormGroup.get('portability_phone').disable();
            this.secondFormGroup.get('iccid').clearValidators();
            this.secondFormGroup.get('iccid').updateValueAndValidity();
        } else {
            this.secondFormGroup.get('portability_phone').patchValue('');
            this.secondFormGroup.get('portability_type_client').patchValue('');
            this.secondFormGroup.get('portability_iccid').patchValue('');
            this.secondFormGroup.get('portability_operator').patchValue('');

            this.secondFormGroup.get('portability_phone').clearValidators();
            this.secondFormGroup.get('portability_type_client').clearValidators();
            this.secondFormGroup.get('portability_iccid').clearValidators();
            this.secondFormGroup.get('portability_operator').clearValidators();

            this.secondFormGroup.get('portability_phone').enable();
        }

        if ((this.typeOperation === 'registration' || this.typeOperation === 'portability') && !this.isAmenaEnCasa) {
            this.secondFormGroup.get('iccid').setValidators([Validators.required, iccidValidator(this.digoService)]);
        } else {
            this.secondFormGroup.get('iccid').patchValue('');
            this.secondFormGroup.get('iccid').clearValidators();
        }

        this.secondFormGroup.get('iccid').updateValueAndValidity();
        this.secondFormGroup.get('portability_phone').updateValueAndValidity();
        this.secondFormGroup.get('portability_operator').updateValueAndValidity();
        this.secondFormGroup.get('portability_type_client').updateValueAndValidity();
        this.secondFormGroup.get('portability_iccid').updateValueAndValidity();
        this.secondFormGroup.get('portability_client').updateValueAndValidity();

        // Validación de terminal
        if (this.terminal != null) {
            this.terminal.changeTypeOperation(this.typeOperation);
        }

    }

    changePortabilityTypeClient(value) {
        this.secondFormGroup.get('portability_iccid').clearValidators();
        if (value === 'postpaid') {
            this.secondFormGroup.get('portability_iccid').setValidators(iccidValidator(this.digoService));
        } else {
            this.secondFormGroup.get('portability_iccid').setValidators([Validators.required, iccidValidator(this.digoService)]);
        }

        this.secondFormGroup.get('portability_iccid').updateValueAndValidity();
    }

    validate() {
        this.isPostpaidClearValidation();
        // this.isNotIccidClear();
        this.addItemToCart();
        this.secondFormGroup.markAllAsTouched();
        this.secondFormGroup.updateValueAndValidity();
        if (this.secondFormGroup.get('terminal').validator != null) {
            this.terminal.errorForm = !this.secondFormGroup.get('terminal').valid;
        }

        if (this.secondFormGroup.valid) {
            this.stepperChild.next();
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');
            if (elements.length > 0) {
                elements[0].focus();
            }
        }
    }

    back() {
        this.stepperChild.previous();
    }

    addNewLine() {
        this.isPostpaidClearValidation();
        // this.isNotIccidClear();
        this.secondFormGroup.markAllAsTouched();
        this.secondFormGroup.updateValueAndValidity();
        if (this.secondFormGroup.valid) {
            // TODO seguramente eliminar
            // this.amenaService.setMuestraBotones(false);
            this.addItemToCart();
            this.amenaListener.addNewMobilePack();
        } else {
            if (this.secondFormGroup.get('terminal').validator != null) {
                this.terminal.errorForm = !this.secondFormGroup.get('terminal').valid;
            }

            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');
            if (elements.length > 0) {
                elements[0].focus();
            }
        }
    }

    addItemToCart() {
        this.secondFormGroup.get('stepper_index').patchValue(this.stepperChild.selectedIndex);
        this.generalService.setFormularioMobilePack(this.secondFormGroup);
    }

    editRate() {
        this.rate = null;
    }

    isPostpaidClearValidation() {
        if (this.secondFormGroup.get('portability_type_client').value === 'postpaid') {
            this.secondFormGroup.get('portability_iccid').patchValue('');
            this.secondFormGroup.get('portability_iccid').setValidators([]);
            this.secondFormGroup.get('portability_iccid').clearValidators();
            this.secondFormGroup.get('portability_iccid').updateValueAndValidity();
        }
    }

    // UserDataListener
    onSuccessfulValidation(userData: UserDataModel) {
        this.secondFormGroup.get('portability_client').patchValue(userData);
    }

    // RateListener
    onSelectRate(rate: Rate) {
        this.rate = rate;
        this.secondFormGroup.get('rate').patchValue(rate);
        this.secondFormGroup.get('terminal').clearValidators();
        this.secondFormGroup.get('stepper_index').patchValue(this.stepperChild.selectedIndex);
        this.isAmenaEnCasa = false;

        if (this.index === 0) {
            this.mobilePackService.setRate(rate);
        }
        if (rate.type === '4G') {
            this.isAmenaEnCasa = true;
            this.typeOperation = 'registration_logistica';
            this.secondFormGroup.get('type_operation').patchValue('registration_logistica');
        }

        setTimeout(() => {
            if ((this.index > 0 || (this.index === 0 && this.router === '/amena/solo_movil')) && rate.type === '4G') {
                // Descomentar para que amena en casa sea obligatorio el terminal
                // this.secondFormGroup.get('terminal').setValidators(Validators.required);
                if (this.secondFormGroup.get('terminal').value && this.secondFormGroup.get('terminal').value !== '' && this.terminal.type !== 'home') {
                    this.secondFormGroup.get('terminal').patchValue('');
                    this.secondFormGroup.get('terminal_payment_type').patchValue('');
                    this.secondFormGroup.get('terminal_insurance').patchValue('');
                }
                this.terminal.type = 'home';
            }

            if (this.secondFormGroup.get('terminal').value && this.secondFormGroup.get('terminal').value !== '') {
                this.terminal.terminal = this.secondFormGroup.get('terminal').value;
                this.terminal.paymentType = this.secondFormGroup.get('terminal_payment_type').value;
            }

            this.secondFormGroup.get('terminal').updateValueAndValidity();
        }, 500);
        this.changeTypeOperation();
        this.setTechnologyLineasAdicionales();
    }

    // TerminalListener
    onSelectTerminal(terminal: TerminalModel, paymentType: string) {
        //this.secondFormGroup.get('stepper_index').patchValue(this.stepperChild.selectedIndex);
        this.secondFormGroup.patchValue({ terminal });
        this.secondFormGroup.patchValue({ terminal_payment_type: paymentType });
    }

    onDeleteTerminal() {
        this.secondFormGroup.patchValue({ terminal: null });
    }

    getIndex(): number {
        return this.index;
    }

    resetForm() {
        this.secondFormGroup.reset();
    }

    addPrefix() {
        if (this.secondFormGroup.get('iccid').value === '') {
            this.secondFormGroup.get('iccid').patchValue('893401');
        }
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
        this.resetForm();
    }

    thereIsOffer(rate: Rate, name: string): boolean {
        return (rate && rate.offers && rate.offers.length && rate.offers[0][name]);
    }

    openModalICCID(content) {
        this.modalService.open(content, {size: 'md', centered: true});
    }
}
